"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./skip-link.css");
var _excluded = ["href", "target"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A hidden link allowing keyboard and screen reader users to easily skip from the beginning
 * of a page to another section. Skip links are hidden off screen by default and are moved
 * to the top left corner of the page when a user focuses on them.
 *
 * A common use case for skip links is to skip navigation and proceed directly to the primary
 * content of a page.
 *
 * For browser compatibility, SkipLink moves the browser's focus to the first
 * heading element inside of the SkipLink's target. As such, when using you
 * should be sure that your content area has a heading.
 *
 * To learn more about skip links, see
 * [WebAIM's article on the subject](http://webaim.org/techniques/skipnav/).
 */
var SkipLink = function SkipLink(_ref) {
  var href = _ref.href,
    target = _ref.target,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-skipLinkWrapper invisible"
  }, /*#__PURE__*/_react["default"].createElement("a", _extends({
    className: "inline-block bg-greenAccent color-textWhite text-bold text-noUnderline sb-skipLink visible"
    // Style matches a positive button, but doesn't use the Button component
    // as we don't want the associated Button focus styles.
    ,
    href: href || "#".concat(target),
    onClick: function onClick(ev) {
      // Prevent default to stop iOS VoiceOver from ignoring focused
      // content with matching URL hash (it actually does this, yes).
      // https://bugs.webkit.org/show_bug.cgi?id=163658
      ev.preventDefault();

      // Find and focus on first heading element inside target element. iOS
      // VoiceOver doesn't support focusing on container elements.
      // https://bugs.webkit.org/show_bug.cgi?id=174099
      var element = document.getElementById(target);
      var focusTarget = element.querySelector('h1, h2, h3, h4, h5, h6');
      if (focusTarget) {
        focusTarget.focus();
      } else {
        element.focus();
      }
    }
  }, otherProps)));
};
SkipLink.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Optional `href` for the link. By default, `SkipLink` will contruct an appropriate
   * `href` based on the `target`. However, ff you modify the browser's default hash link
   * behavior by using an HTML `<base>` tag or similar, you may need to provide a complete
   * `href`.
   */
  href: _propTypes["default"].string,
  /**
   * HTML ID attribute of the target element.
   * Activating the skip link will jump the users browser to the target element.
   */
  target: _propTypes["default"].string.isRequired
} : {};
SkipLink.displayName = 'SkipLink';
var _default = exports["default"] = SkipLink;